import LocalStrings from '../../assets/languages';
import MaxLength from '../MaxLengths';

export const ALLOWED_COMMUNITY_CATEGORIES = {
  post: ['post', 'ice', 'job', 'meetup'],
  group: ['group'],
  nocreate: ['group', 'ice']
};

export const COMMUNITY_POST_FORMS = {
  ice: [
    {
      name: 'title',
      label: LocalStrings.dynamic.kIntroduction,
      placeholder: LocalStrings.dynamic.kIntroductionPlaceholder,
      key: 'textinput',
      show: true,
      value: '',
      required: true,
      extra: false,
      maxlen: MaxLength.community_create_post_title
    },
    {
      name: 'text1',
      label: LocalStrings.dynamic.kIceBreakerQuestion,
      noplaceholder: true,
      key: 'dropdown',
      show: true,
      value: '',
      options: null,
      required: false,
      extra: true
    },
    {
      name: 'text2',
      label: null,
      key: 'text',
      show: false,
      value: '',
      required: false,
      extra: true
    },
    {
      name: 'description',
      label: LocalStrings.dynamic.kYourAnswer,
      placeholder: LocalStrings.dynamic.kEnterAnswer,
      key: 'textarea',
      show: true,
      value: '',
      required: true,
      extra: false,
      maxlen: MaxLength.community_intro_desc
    }
  ],
  post: [
    {
      name: 'title',
      label: LocalStrings.dynamic.kPostTitleText,
      placeholder: LocalStrings.dynamic.kPostTitlePlaceholder,
      key: 'textinput',
      show: true,
      value: '',
      required: true,
      extra: false,
      maxlen: MaxLength.community_create_post_title
    },
    {
      name: 'description',
      label: LocalStrings.dynamic.kPostDetailsText,
      placeholder: LocalStrings.dynamic.kPostDetailsPlaceholder,
      key: 'textarea',
      show: true,
      value: '',
      required: true,
      extra: false,
      maxlen: MaxLength.community_create_post_desc
    }
  ],
  job: [
    {
      name: 'title',
      label: LocalStrings.dynamic.kJobTitle,
      placeholder: LocalStrings.dynamic.kJobTitlePlaceholder,
      key: 'textinput',
      show: true,
      value: '',
      required: true,
      extra: false,
      maxlen: MaxLength.community_create_post_title
    },
    {
      name: 'text2',
      label: LocalStrings.dynamic.kJobType,
      noplaceholder: true,
      key: 'dropdown',
      show: true,
      value: '',
      options: [
        { text: LocalStrings.dynamic.kJobFullTime, show: true, value: 'FT' },
        { text: LocalStrings.dynamic.kJobPartTime, show: true, value: 'PT' }
      ],
      required: false,
      extra: true
    },
    {
      name: 'text1',
      label: LocalStrings.dynamic.kJobLocation,
      placeholder: LocalStrings.dynamic.kMeetupLocationPlaceholder,
      key: 'textinput',
      show: true,
      value: '',
      required: true,
      extra: true,
      maxlen: MaxLength.community_create_post_title
    },
    {
      name: 'description',
      label: LocalStrings.dynamic.kJobDesc,
      placeholder: LocalStrings.dynamic.kJobDescPlaceholder,
      key: 'textarea',
      show: true,
      value: '',
      required: true,
      extra: false,
      maxlen: MaxLength.community_job_desc
    },
    {
      name: 'exhibitoridfk',
      label: LocalStrings.dynamic.kLinkedExhibitor,
      key: 'dropdown',
      show: true,
      value: '',
      options: [],
      required: true,
      extra: true
    },
    {
      name: 'eType',
      label: LocalStrings.dynamic.kWhenApply,
      noplaceholder: true,
      key: 'dropdown',
      show: true,
      value: '',
      options: [
        {
          text: LocalStrings.dynamic.kCollectAsLeads,
          show: true,
          value: 'lead'
        },
        {
          text: LocalStrings.dynamic.kOpenExternalUrl,
          show: true,
          value: 'ext'
        }
      ],
      required: false,
      extra: true
    },
    {
      name: 'linkUrl',
      label: LocalStrings.dynamic.kExternalUrl,
      placeholder: LocalStrings.dynamic.kExternalUrlPlaceholder,
      key: 'textinput',
      show: false,
      value: '',
      required: true,
      extra: false
    }
  ],
  meetup: [
    {
      name: 'eType',
      label: LocalStrings.dynamic.kMeetupType,
      noplaceholder: true,
      key: 'dropdown',
      show: true,
      value: '',
      options: [
        {
          text: LocalStrings.dynamic.kInPerson,
          show: true,
          value: 'in-person'
        },
        { text: LocalStrings.dynamic.kVirtual, show: true, value: 'virtual' }
      ],
      required: false,
      extra: true
    },
    {
      name: 'title',
      label: LocalStrings.dynamic.kMeetupTitle,
      placeholder: LocalStrings.dynamic.kMeetupTitlePlaceholder,
      key: 'textinput',
      show: true,
      value: '',
      required: true,
      extra: false,
      maxlen: MaxLength.community_create_post_title
    },
    {
      name: 'description',
      label: LocalStrings.dynamic.kMeetupDesc,
      placeholder: LocalStrings.dynamic.kMeetupDescPlaceholder,
      key: 'textarea',
      show: true,
      value: '',
      required: true,
      extra: false,
      maxlen: MaxLength.community_meetup_desc
    },
    {
      name: 'text2',
      label: LocalStrings.dynamic.kMeetupDate,
      placeholder: LocalStrings.dynamic.kSelectDatePlaceholder,
      key: 'datetimepicker',
      show: true,
      value: '',
      required: true,
      extra: true
    },
    {
      name: 'text1',
      label: LocalStrings.dynamic.kMeetupLocation,
      placeholder: LocalStrings.dynamic.kMeetupLocationPlaceholder,
      key: 'textinput',
      show: true,
      value: '',
      required: true,
      extra: true
    }
  ]
};

export const ALLOWED_COMMUNITY_MEMBERSHIP_TYPES = {
  requested: 'requested',
  accepted: 'accepted',
  removed: 'removed',
  left: 'left',
  rejected: 'rejected'
};
